export default __webpack_public_path__ + "static/logo-black-358ad06fdb8d84152e850532131411a4.svg";